module.exports = __webpack_public_path__ + "img/cooperate_yh_08@2x.13ace0f9.png";